"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransformProjectFont = void 0;
const TransformObject_1 = require("./TransformObject");
class TransformProjectFont extends TransformObject_1.TransformObject {
    constructor(parent, baseFont) {
        super(parent, {
            baseFont: baseFont.type === 'browser' ? baseFont : { ...baseFont, glyphs: {} },
        }, baseFont.name, new Set());
        this.deduplicationKey = baseFont.name;
    }
    compile() {
        return this._sharedData.baseFont;
    }
}
exports.TransformProjectFont = TransformProjectFont;
//# sourceMappingURL=TransformProjectFont.js.map